export function formatPhoneNumber(phone: string) {
  const digits = phone.replace(/\D/g, "");

  let countryCode = "";
  let mainNumber = digits;

  // If more than 10 digits, treat leading 1–3 digits as country code
  if (digits.length > 10) {
    countryCode = digits.slice(0, digits.length - 10) + "-";
    mainNumber = digits.slice(-10);
  }

  // Must have exactly 10 digits in main number
  if (mainNumber.length !== 10) return phone;

  const formatted = mainNumber.replace(/^(\d{3})(\d{3})(\d{4})$/, "$1-$2-$3");
  return countryCode + formatted;
}
